import request from '@/utils/request'
import ucenter_request from '@/utils/ucenter_request.js'


export function get_sheng(params) { // 省
  return ucenter_request({
    url: '/user/address/getPCCList',
    method: 'get',
    params
  })
}

export function get_list(params) { // 获取地址列表
  return request({
    url: '/user/address/getUserAddressList',
    method: 'get',
    params
  })
}

export function set_default_address(params) { // 设置默认地址
  return request({
    url: '/user/address/updateAddress',
    method: 'get',
    params
  })
}

export function commits_emits(params) { // 提交邮箱
  return request({
    url: '/personal/myInfo/directSetEmail',
    method: 'get',
    params
  })
}
export function add_myaddress(params) { // 添加修改地址/user/address/getPCCList
  return request({
    url: '/user/address/editAddress',
    method: 'get',
    params
  })
}

export function get_imgId(params) {
  return request({
    url: 'personal/Certification/searchCertification',
    method: 'get',
    params
  })
}
export function get_img(params) {
  return request({
    url: 'personal/certification/downCertification',
    method: 'get',
    params
  })
}
export function get_infos(params) {
  return request({
    url: 'personal/Certification/getCertificationInfo',
    method: 'get',
    params
  })
}